import React from "react";
import { Box, Flex, Heading, Text } from "theme-ui";
import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { colors, typography } from "../../../styles/theme";
import dataContent from "../../../data/homeME/aboutFeature.yml";

const AboutFeature = () => {
    const data = useStaticQuery(graphql`
        query {
          featureImageDesktop: file(relativePath: { eq: "home/Images-ME/AboutDesktop.png" }) {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, height: 384)
            }
          }
          featureImageTablet: file(relativePath: { eq: "home/Images-ME/AboutTablet.png" }) {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, height: 248)
            }
          }
          featureImageMobile: file(relativePath: { eq: "home/Images-ME/AboutMobile.png" }) {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, height: 230)
            }
          }
        }
      `);

    const images = [
        { image: getImage(data.featureImageMobile), display: displayConfig[0] },
        { image: getImage(data.featureImageTablet), display: displayConfig[1] },
        { image: getImage(data.featureImageDesktop), display: displayConfig[2] },
    ];

    return (
        <Box sx={{ px: ["1rem", "1rem", "2rem", "4rem"] }}>
            <Heading as="h2" sx={headingContainer}>
                About
                <span style={{ color: colors.primary700 }}> greytHR </span>
            </Heading>
            <Flex sx={containerStyles}>
                <Box sx={imageContainer}>
                    {images.map(({ image, display }, index) => (
                        <Box key={`about-image-${index}`} sx={{ display }}>
                            <GatsbyImage image={image} alt="About greytHR feature" />
                        </Box>
                    ))}
                </Box>
                <Box sx={{ flex: 1, mr: ['0', '0', '1rem'] }}>
                    {dataContent.slice(0, 3).map((item, index) => (
                        <Box key={`data-content-${index}`} sx={contentContainer}>
                            <Heading as="h5" sx={headingStyles}>
                                {item.title}
                                <span style={bulletStyles} />
                            </Heading>
                            <Text sx={typography.textMd400}>{item.description}</Text>
                        </Box>
                    ))}
                </Box>
                <Box sx={{ flex: 1 }}>
                    {dataContent.slice(3).map((item, index) => (
                        <Box key={`data-content-${index}`} sx={contentContainer}>
                            <Heading as="h5" sx={headingStyles}>
                                {item.title}
                                <span style={bulletStyles} />
                            </Heading>
                            <Text sx={typography.textMd400}>{item.description}</Text>
                        </Box>
                    ))}
                </Box>
            </Flex>
        </Box>
    );
};

const displayConfig = [
    ["block", "block", "none", "none"],
    ["none", "none", "block", "none"],
    ["none", "none", "none", "block"],
];

const { headingContainer, containerStyles, imageContainer, contentContainer, bulletStyles, headingStyles } = {
    headingContainer: {
        ...typography.h2,
        p: { m: 0 },
        textAlign: "center",
        mb: ["3rem", "3rem", "3rem", "4rem"],
    },
    containerStyles: {
        flexDirection: ['column', 'column', 'column', 'row'],
        maxWidth: ["24.75rem", "24.75rem", "44rem", "72rem"],
        justifyContent: 'center',
        mx: 'auto',
        width: '100%',
    },
    imageContainer: {
        maxWidth: "100%",
        mx: "auto",
        mb: ["2rem", "2rem", "3rem", 0],
        "@media(min-width: 900px)": {
            mr: "3rem"
        },
    },
    contentContainer: {
        mb: ['2rem', '2rem', '2rem', '1rem'],
        maxWidth: ["24.75rem", "24.75rem", "43.938rem", "23.75rem"]
    },
    bulletStyles: {
        display: 'inline-block',
        width: '0.875rem',
        height: '0.875rem',
        borderRadius: '50%',
        backgroundColor: colors.primaryMain,
        marginLeft: '0.5rem'
    },
    headingStyles: {
        ...typography.h5,
        mb: '0.75rem',
        alignItems: 'center'
    }
};

export default AboutFeature;
